import type UserService from '../../../user/user.service';
import type {User} from 'typings/portaro.be.types';


export class KpSearchItemUserPresenter {
    public static presenterName = 'kpSearchItemPresenter';

    /*@ngInject*/
    constructor(private userService: UserService) {}

    public editUser(user: User) {
        return this.userService.editUserByForm(user);
    }

    public async deleteUser(user: User) {
        await this.userService.deleteUser(user);
    }
}